// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CMd-B","textarea":"styles_textarea__aWMe8"};